import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useMutation } from '@apollo/react-hooks';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Formik, Field } from 'formik';
import { Form, Input, Button, Card, Alert, message } from 'antd';

import { FormInputField } from '../FormInputField/FormInputField';

import validators from '../../validators/validators';
import { mutations } from '../../graphql/graphql';
import actions from '../../store/actions/actions';
import EmailSent from './EmailSent';

import _s from './ForgotPassword.less';

const ForgotPassword = () => {
  const [resetEmail, setResetEmail] = useState();
  const [ForgotPassword] = useMutation(mutations.FORGOT_PASSWORD);

  const handleSubmitForm = async (values, actions) => {
    const { email } = values;
    const { setErrors, setSubmitting } = actions;
    ForgotPassword({ variables: { email } }).then(
      res => {
        message.success('A link to reset your password has been sent to your mailbox');
        setSubmitting(false);
        setResetEmail(email);
      },
      err => {
        setSubmitting(false);
        err.graphQLErrors.map(x => {
          console.log(x.message);
          setErrors({ auth: x.message });
        });
        setErrors({ auth: 'Incorrect email.' });
      }
    );
  };
  if (resetEmail) {
    return <EmailSent email={resetEmail} />;
  }

  return (
    <Card className={_s.LoginFormCard}>
      <p style={{ fontWeight: 'bold', fontSize: '1.05rem' }}>Reset password</p>

      <Formik
        initialValues={{ email: '' }}
        validationSchema={validators.user.forgotPasswordSchema}
        validateOnChange={false}
        validateOnBlur={false}
        onSubmit={(values, actions) => handleSubmitForm(values, actions)}
        render={formikProps => {
          const { errors, isSubmitting, handleSubmit } = formikProps;
          return (
            <>
              {Object.keys(errors).length > 0 && (
                <Alert
                  message={errors.email || errors.auth}
                  type="error"
                  showIcon
                  style={{ marginBottom: '1.05rem', maxWidth: '300px' }}
                />
              )}
              <Form onFinish={handleSubmit}>
                <Field
                  InputType={Input}
                  component={FormInputField}
                  name="email"
                  placeholder="Email"
                  hideErrorMessage={true}
                />
                <Form.Item style={{ marginBottom: 'unset' }}>
                  <Button
                    type="primary"
                    htmlType="submit"
                    loading={isSubmitting}
                    className={_s.loginFormButton}
                  >
                    Reset password
                  </Button>
                </Form.Item>
              </Form>
            </>
          );
        }}
      />
    </Card>
  );
};

const mapStateToProps = state => {
  return {
    user: state.auth.user,
    loggedIn: state.auth.loggedIn
  };
};

const mapDispatchToProps = dispatch => {
  return bindActionCreators(
    {
      setAuthUser: actions.setAuthUser
    },
    dispatch
  );
};

ForgotPassword.propTypes = {
  loggedIn: PropTypes.bool.isRequired,
  setAuthUser: PropTypes.func.isRequired,
  user: PropTypes.object
};

export default connect(mapStateToProps, mapDispatchToProps)(ForgotPassword);
